import { createSmsApi } from "@growing/api";
import { apiClient } from "../client";

// 공유 패키지에서 타입 re-export (기존 인터페이스 유지)
export type {
  SendSmsRequest,
  SendSmsResponse,
  VerifySmsRequest,
  VerifySmsResponse,
} from "@growing/api";

// 공유 패키지의 API 사용
const smsApi = createSmsApi(apiClient);

// 기존 함수명 유지 (래퍼)
export const postSendSms = smsApi.sendSms;
export const postVerifySms = smsApi.verifySms;
